<template>
  <v-container class="fill-height eservice_type" fluid>
    <v-layout class="eservice_inner_wrap login_wrap type2">
      <v-flex class="pa-0 login_content type2">

        <v-form
          v-model="valid"
          lazy-validation
        >
          <v-card class="login_form type2 type3" flat>
            <div class=" d-flex align-center">
              <h2 class="logo mb-25">
                <v-img src="~@/assets/img/logo_auth.png" alt="EGPO" @click="$router.push('/main')" style="cursor:pointer;"></v-img>
              </h2>
              <v-spacer></v-spacer>
             <div class="lang__selector ty2">
              <v-switch
                v-model="rtl"
                color="red"
                value="red"
                class=""
                hide-details
                @change="fnSetLocale()"
              ></v-switch>
              <v-spacer class="hidden_lr5"></v-spacer>
              <span v-if="rtl">{{ $t('common.common.arabic') }}</span>
              <span v-else>{{ $t('common.common.english') }}</span>
            </div>
            </div>
            <h3 class="out_title mb-15">{{ $t('signup.title') }}</h3>

            <h2 class="login_f_title mt-30 pl-35 pr-35" style="font-size:14px!important; font-weight:500;">
              {{ $t('signup.common.email.fields.user_type') }}
            </h2>

            <v-card-text class="pa-0 inner_item_content mb-0">
              <v-row class="ma-0">
                <v-col cols="12" class="pa-0 mb-35">
                  <h2 class="nec_title mb--10" style="font-size:14px!important;">{{ $t('signup.common.email.fields.select_type') }}</h2>
                  <v-row class="ma-0 user_type_btn_wrap">
                    <v-btn class="mb-15 big" :class="{'active' : active1}" @click="fnSetUserTypeCode('2701')">
                      <v-icon>mdi-domain</v-icon>{{ $t('signup.common.email.fields.company') }}
                    </v-btn>
                    <v-btn class="mb-15 big" :class="{'active' : active3}" @click="fnSetUserTypeCode('2703')">
                      <v-icon>mdi-account-search-outline</v-icon>{{ $t('signup.common.email.fields.search_enterprise') }}
                    </v-btn>

                    <v-btn :class="{'active' : active4}" @click="fnSetUserTypeCode('2704')">
                      <v-icon>mdi-account-circle</v-icon>{{ $t('signup.common.email.fields.individual') }}
                    </v-btn>
                    <v-btn :class="{'active' : active5}" @click="fnSetUserTypeCode('2705')">
                      <v-icon>mdi-school</v-icon>{{ $t('signup.common.email.fields.student') }}
                    </v-btn>
                    <v-btn :class="{'active' : active6}" @click="fnSetUserTypeCode('2706')">
                      <v-icon>mdi-hospital-building</v-icon>{{ $t('signup.common.email.fields.university') }}
                    </v-btn>
                  </v-row>
                </v-col>
              </v-row>
            </v-card-text>

            <h2 class="login_f_title mt-25 pl-35 pr-35" style="font-size:14px!important;">
              {{ $t('signup.common.email.fields.create_your_account') }}
            </h2>

            <v-card-text class="pa-0 inner_item_content mb-30">
              <v-row class="ma-0">
                <v-col cols="12" class="pa-0 mb-35">
                  <h3 class="alert_text_title mb-20" style="font-size:13px!important; font-weight:400; line-height:20px;">{{ $t('signup.common.email.fields.enter_id_notice') }}</h3>
                  <h2 class="nec_title mb-15" style="font-size:14px!important;"><i>*</i> {{ $t('signup.common.email.fields.email') }}</h2>
                  <v-text-field
                    label=""
                    solo
                    outlined
                    flat
                    dense
                    clearable
                    class="login_text_filed email"
                    v-model="email"
                    v-validate="'required|email'"
                    :error-messages="errors.collect('email')"
                    data-vv-name="email"
                    :data-vv-as="$t('signup.common.email.fields.email')"
                    append-icon="mdi-alert"
                  ></v-text-field>
                </v-col>

                <v-col cols="12" class="pa-0 mb-35" v-show="user_type_code === '2701' || user_type_code === '2702' || user_type_code === '2703' || user_type_code === '2706'">
                  <h2 class="nec_title mb-15" style="font-size:14px!important;"><i>*</i> {{ $t('signup.common.email.fields.inner_title_dtl1') }}</h2>
                  <v-text-field
                    label=""
                    solo
                    outlined
                    flat
                    dense
                    clearable
                    class="login_text_filed"
                    v-model="company_regiration_no"
                    v-validate="requiredCompanyRegistrationNumber"
                    :error-messages="errors.collect('companyRegistrationNumber')"
                    data-vv-name="companyRegistrationNumber"
                    :data-vv-as="$t('signup.common.email.fields.inner_title_dtl1')"
                    append-icon="mdi-alert"
                  ></v-text-field>
                </v-col>

                <v-col cols="12" class="pa-0 mb-35" v-show="user_type_code === '2704' || user_type_code === '2705'">
                  <h2 class="nec_title mb-15" style="font-size:14px!important;"><i>*</i> {{ $t('signup.common.email.fields.inner_title_dtl2') }}</h2>
                  <v-text-field
                    label=""
                    solo
                    outlined
                    flat
                    dense
                    clearable
                    class="login_text_filed"
                    v-model="personal_identify_no"
                    v-validate="requiredPersonalIdentityNumber"
                    :error-messages="errors.collect('personalIdentityNumber')"
                    data-vv-name="personalIdentityNumber"
                    :data-vv-as="$t('signup.common.email.fields.inner_title_dtl2')"
                    append-icon="mdi-alert"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-card-text>

            <v-row class="ma-0 btn_wrap pb-30">
              <v-btn class="sign_in_btn type2 colorwh" :loading="isActiveBtn" text @click="fnCheck()">{{ $t('common.button.check') }}</v-btn>
            </v-row>

            <v-card
              flat
              class="foot__info type2 mb-40"
              v-if="footinfo"
            >
              <v-card-text class="pa-0">
                <div class="d-flex">
                  <p class="d-inline-block">{{ footInfoMsg }}</p>
                </div>
              </v-card-text>
            </v-card>
          </v-card>
        </v-form>
      </v-flex>
    </v-layout>
    <v-row justify="center">
      <v-dialog v-model="dialog" persistent max-width="500">
        <v-card>
          <v-card-title>{{$t('signup.common.email.fields.company_regiration_no_exist_msg', {company_name: ($vuetify.rtl ? company_name_ar : company_name_en)})}}</v-card-title>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn class="sb_btn btn-actv" @click="fnSuccess">{{$t('common.button.yes')}}</v-btn>
            <v-btn class="sb_btn btn-dactv" @click="fnCancel">{{$t('common.button.no')}}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
  </v-container>
</template>

<script>
import en from 'vee-validate/dist/locale/en'
import ar from 'vee-validate/dist/locale/ar'
import requestApi from '@/utils/requestApi'
import store from '@/store'
import utils from '@/utils/utils'
import eventBus from '@/utils/eventBus'

export default {
  components: {
  },
  data () {
    return {
      userTypeCodeListAr: [],
      userTypeCodeListEn: [],

      active1:false,
      active2:false,
      active3:false,
      active4:false,
      active5:false,
      active6:false,

      isActiveBtn : false,
      footinfo :false,
      footInfoMsg : '',

      valid :true,

      email: '',
      user_type_code: '2701',
      personal_identify_no: '',
      company_regiration_no: '',
      company_name_ar: '',
      company_name_en: '',
      requiredCompanyRegistrationNumber: 'required',
      requiredPersonalIdentityNumber: 'required|digits:14',

      rtl: (store.state.api.language === 'en') ? null: 'red',

      // 컨펌 관련
      dialog: false,
      title: '',
      text: ''
    }
  },
  mounted () {
    window.scrollTo(0, 0)
    this.fnInit()
  },
  methods: {
    fnInit() {
      let options = {
        upper_code: '2700',
        all: true
      }
      utils.fnGetCodeList(options).then(list => {
        this.userTypeCodeListAr = list.ar
        this.userTypeCodeListEn = list.en
      })
      if (this.$vuetify.rtl) {
        this.$validator.localize('ar', ar)
      } else {
        this.$validator.localize('en', en)
      }

      this.fnSetUserTypeCode('2701')
    },

    fnSetUserTypeCode(code){
      this.user_type_code = code

      this.active1 = false
      this.active2 = false
      this.active3 = false
      this.active4 = false
      this.active5 = false
      this.active6 = false

      this.requiredCompanyRegistrationNumber = 'required',
      this.requiredPersonalIdentityNumber = ''

      switch(code){
        case '2701' :
          this.active1 = true
          break
        case '2702' :
          this.active2 = true
          break
        case '2703' :
          this.active3 = true
          break
        case '2704' :
          this.active4 = true
          this.requiredCompanyRegistrationNumber = '',
          this.requiredPersonalIdentityNumber = 'required|digits:14'
          break
        case '2705' :
          this.active5 = true
          this.requiredCompanyRegistrationNumber = '',
          this.requiredPersonalIdentityNumber = 'required|digits:14'
          break
        case '2706' :
          this.active6 = true
          break
      }
    },

    fnCheck() {
      this.$validator.validateAll().then((valid) => {
        if(valid){
          this.isActiveBtn = true
          let params = {
            company_regiration_no : this.company_regiration_no
          }
          if(this.user_type_code == '2704' || this.user_type_code == '2705'){
            params = {
              email : this.email,
              user_type_code : this.user_type_code,
              personal_identify_no : this.personal_identify_no
            }
            this.fnVerifyAccount(params)
          } else {
            requestApi({
              url: '/autho/verify/company',
              data: params,
              method: 'GET',
              callback: (res) => {
                if (res.res_code === '200') {
                  if (res.data.seq > 0) {
                    this.company_name_ar = res.data.name_ar
                    this.company_name_en = res.data.name_en

                    this.fnConfirmShow()
                  } else {
                    params = {
                      email : this.email,
                      user_type_code : this.user_type_code,
                      company : {
                        ind_success : 'Y',
                        company_regiration_no : this.company_regiration_no
                      }
                    }
                    this.fnVerifyAccount(params)
                  }
                } else {
                  let option = {
                    text : (this.$vuetify.rtl) ? res.res_msg_ar: res.res_msg_en
                  }
                  eventBus.$emit('SHOW_SNACKBAR', option)
                  this.isActiveBtn = false
                }
              }
            })
          }
        }
      })
    },
    fnConfirmShow(){
      this.dialog = true
    },
    fnCancel(){
      this.isActiveBtn = false
      this.dialog = false
    },
    fnSuccess(){
      this.dialog = false
      let params = {
        email : this.email,
        user_type_code : this.user_type_code,
        company : {
          ind_success : 'Y',
          company_regiration_no : this.company_regiration_no
        }
      }

      this.fnVerifyAccount(params)
    },

    fnVerifyAccount(params) {
      requestApi({
        url: '/autho/verify/account',
        method: 'POST',
        data: params,
        callback: (res) => {
          let option = {
            text : (this.$vuetify.rtl) ? res.res_msg_ar: res.res_msg_en
          }
          eventBus.$emit('SHOW_SNACKBAR', option)
          this.isActiveBtn = false
        }
      })
    },

    fnSetLocale() {
      if (this.$vuetify.rtl) {
        this.rtl = null
        this.$vuetify.rtl = false
        this.$i18n.locale = 'en'
        this.$vuetify.lang.current = 'en'
        this.$validator.localize('en', en)
        store.dispatch('SetLanguage', 'en')
      } else {
        this.rtl = 'red'
        this.$vuetify.rtl = true
        this.$i18n.locale = 'ar'
        this.$vuetify.lang.current = 'ar'
        this.$validator.localize('ar', ar)
        store.dispatch('SetLanguage', 'ar')
      }
      this.fnSetUserTypeCode(this.user_type_code)
    },
  }

}
</script>
